import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-marcaje-export-dialog',
  templateUrl: './marcaje-export-dialog.component.html',
  styleUrls: ['./marcaje-export-dialog.component.scss'],
  providers: []
})
export class MarcajeExportDialog {

  localHour: boolean = true;
  disabled: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<MarcajeExportDialog>,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
  ) {

  }



  changeLocalHour(event: any) {
    this.localHour = event.value;
  }

  changeDisabled(event: any) {
    this.disabled = event.value;
  }

  closePopUp() {
    this.dialogRef.close();
  }

  downloadFile() {
    const resultData = {
      localHour: this.localHour,
      disabled: this.disabled
    };
    this.dialogRef.close(resultData);
  }
}
